import React, { Component } from "react";
import { Link } from "react-router-dom";

import Header from "../../component/Header";
import HeaderAudioBook from "../../component/HeaderAudioBook";
import BottomNav from "../../component/BottomNav";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";

import SearchBookList from "../../component/SearchBookList";
import BookListViewByAuthor from '../BookListViewByAuthor';

import cookie from 'react-cookie';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

class SVByAuthor extends Component {
	state = {
		headerTitle: "더책-저자",
		query: "",
		loading: true,
		data: [],
		booklist: [],
        bl_url:"/blbyauthor"
	};

	constructor(props) {
		super(props);

                    if( window.location.pathname.toLowerCase().indexOf("audiobook")>0 || 
                       window.location.search.toLowerCase().indexOf("audiobook")>0) {
                         this.state.bl_url="/blbyauthor_audiobook";
                    } else {
                        this.state.bl_url="/blbyauthor";
                    };
	}

	getData = (strquery) => {

		//console.log("aaa: " + strquery + ", " + this.prevState);

		fetch(`/api/AB/AuthorList?pgidx=0&pgsize=50000&orderby=1&orderway=1&search=${strquery}`)
			.then(response => response.json())
			.then(data => {
				//alert(JSON.stringify(data));
				//console.log(JSON.stringify(data));
				const { query } = this.state;
				const booklist = data.lstresult;

				this.setState({
					data,
					booklist
				});
			});
	};

	componentWillMount() {
		this.getData('');
	}

    logPageView() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
    }

    render() {
        this.logPageView();
		//let contents = this.state.loading === true ? "loading..." : this.dorender();
        let contents = "loading...";
        var hdr;
        if(this.state.bl_url.indexOf("audiobook")>-1) {
          hdr= <HeaderAudioBook headerTitle={this.state.headerTitle} />

        } else {
          hdr= <Header headerTitle={this.state.headerTitle} />
        }

		return (
			<React.Fragment>
            {hdr}
            <br/>
				<div className="section-body">
					<React.Fragment>
						<ul className="bookList">
							{this.state.booklist.map((book, index) => {
								return (
									<React.Fragment>
										<li className="bookList-item">
											<Link to={{
												pathname: this.state.bl_url,
												state: {
													authorname: book.author_name
												}
											}}>
												<div className="bookList-info">
													<h3 className="bookList-title">{book.author_name}</h3>
												</div>
											</Link>
										</li>
									</React.Fragment>
								);
							})}
						</ul>
					</React.Fragment>
					
				</div>
			</React.Fragment>
		);
	}
}

export default SVByAuthor;
